/* eslint-disable sorare/no-detached-fragments */
import { TypedDocumentNode, gql } from '@apollo/client';
import { PropsWithChildren } from 'react';

import { RewardBoxDialog as CoreRewardBoxDialog } from '@sorare/core/src/components/rewards/RewardBoxDialog';

import { RewardBoxFallback } from '../RewardBoxFallback';
import { RewardBoxDialog_ProbabilisticBundle } from './__generated__/index.graphql';
import { getPreloaders, useFormatBox } from './utils';

type RewardBoxDialogProps = {
  rewardBoxes: RewardBoxDialog_ProbabilisticBundle[];
  open?: boolean;
  onClose: () => void;
  onClaimed?: () => void;
  disableOnClose?: boolean;
  disableContinue?: boolean;
};
export const RewardBoxDialog = ({
  rewardBoxes,
  open,
  onClose,
  onClaimed,
  disableOnClose,
  disableContinue,
  children,
}: PropsWithChildren<RewardBoxDialogProps>) => {
  const boxes = useFormatBox(rewardBoxes, {
    onClaimed,
  });

  if (rewardBoxes.length === 0) {
    return null;
  }

  return (
    <CoreRewardBoxDialog
      boxes={boxes}
      open={open}
      onClose={onClose}
      disableOnClose={disableOnClose}
      disableContinue={disableContinue}
      preloaders={getPreloaders(rewardBoxes.flatMap(b => b.items))}
      fallbacks={<RewardBoxFallback rewardBoxes={rewardBoxes} />}
    >
      {children}
    </CoreRewardBoxDialog>
  );
};

RewardBoxDialog.fragments = {
  ProbabilisticBundle: gql`
    fragment RewardBoxDialog_ProbabilisticBundle on ProbabilisticBundle {
      id
      ...useFormatBox_ProbabilisticBundle
      ...RewardBoxFallback_ProbabilisticBundle
    }
    ${useFormatBox.fragments.ProbabilisticBundle}
    ${RewardBoxFallback.fragments.ProbabilisticBundle}
  ` as TypedDocumentNode<RewardBoxDialog_ProbabilisticBundle>,
};
